<template>
  <div class="flow-page">
    <!-- 客户信息 -->
    <div class="table-container">
      <div class="page-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">客户信息</h2>
          <div class="header-sub">CUSTOMER INFORMATION</div>
        </div>
      </div>
      <div class="card-body">
        <!-- 基本信息 -->
        <div class="section-title">基本信息</div>
        <div class="info-grid">
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">客户名称</span>
              <span class="info-value">{{ propsParams.customerName || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">业务员</span>
              <span class="info-value">{{ propsParams.salesman || '-' }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">联系人</span>
              <span class="info-value">{{ propsParams.linkman || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">联系人电话</span>
              <span class="info-value">{{ propsParams.linkmanPhone || '-' }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item info-item--full">
              <span class="info-label">公司地址</span>
              <span class="info-value">{{ propsParams.companyAddress || '-' }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">创建登录账号</span>
              <span class="info-value">
                <el-tag v-if="propsParams.createSysUser === 0" type="info" size="small">否</el-tag>
                <el-tag v-else-if="propsParams.createSysUser === 1" type="success" size="small">是</el-tag>
                <span v-else>-</span>
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">用户昵称</span>
              <span class="info-value">{{ propsParams.userName || '-' }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">使用设备</span>
              <span class="info-value">{{ propsParams.useDevice || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">使用场景</span>
              <span class="info-value">{{ propsParams.useScreen || '-' }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">分成模式</span>
              <span class="info-value">
                <el-tag v-if="propsParams.commissionModel === 0" type="primary" size="small">比例模式</el-tag>
                <el-tag v-else-if="propsParams.commissionModel === 1" type="warning" size="small">底价模式</el-tag>
                <el-tag v-else-if="propsParams.commissionModel === 2" size="small">流量池模式</el-tag>
                <span v-else>-</span>
              </span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item info-item--full">
              <span class="info-label">备注</span>
              <span class="info-value">{{ propsParams.remark || '-' }}</span>
            </div>
          </div>
        </div>

        <!-- 分隔线 -->
        <div class="section-divider"></div>

        <!-- 图片资料 -->
        <div class="section-title">图片资料</div>
        <div class="image-grid">
          <div class="image-block">
            <div class="image-block-label">使用设备的图片</div>
            <div class="image-wrap">
              <el-image
                v-if="propsParams.useDevicePicture"
                class="detail-image"
                :src="propsParams.useDevicePicture"
                :preview-src-list="[propsParams.useDevicePicture]"
                fit="cover"
              />
              <div v-else class="image-empty">
                <i class="el-icon-picture-outline"></i>
                <span>暂无图片</span>
              </div>
            </div>
          </div>
          <div class="image-block">
            <div class="image-block-label">营业执照</div>
            <div class="image-wrap">
              <el-image
                v-if="propsParams.businessLicensePicture"
                class="detail-image"
                :src="propsParams.businessLicensePicture"
                :preview-src-list="[propsParams.businessLicensePicture]"
                fit="cover"
              />
              <div v-else class="image-empty">
                <i class="el-icon-picture-outline"></i>
                <span>暂无图片</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 流程图 -->
    <div class="table-container">
      <div class="page-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">流程图</h2>
          <div class="header-sub">PROCESS DIAGRAM</div>
        </div>
      </div>
      <div class="card-body">
        <div v-if="str" class="flow-diagram" v-html="str"></div>
        <div v-else class="empty-block">
          <i class="el-icon-picture-outline"></i>
          <span>暂无流程图</span>
        </div>
      </div>
    </div>

    <!-- 流程历史跟踪 -->
    <div class="table-container">
      <div class="page-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">流程历史跟踪</h2>
          <div class="header-sub">PROCESS HISTORY</div>
        </div>
      </div>
      <div class="flow-table-wrap">
        <el-table :data="tableData" border>
          <el-table-column prop="ids" label="序号" align="center" width="80" />
          <el-table-column prop="activityName" label="名称" align="center" min-width="140" show-overflow-tooltip />
          <el-table-column prop="startTime" label="开始时间" align="center" width="180" />
          <el-table-column prop="endTime" label="结束时间" align="center" width="180" />
          <el-table-column prop="assignee" label="负责人" align="center" width="120" />
          <el-table-column prop="status" label="处理结果" align="center" width="120" />
          <el-table-column prop="reason" label="处理意见" align="center" min-width="160" show-overflow-tooltip />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { processInstanceImage } from "@/api/api.js";
  import { historicActivityInstance } from "@/api/api.js";
  import { getCustomerInfo } from "@/api/api.js";
  export default {
    data() {
      return{
        processId: undefined,
        id: undefined,
        str: "",
        formData: {},
        tableData: [],
        propsParams: {}
      }
    },
    methods: {
      initData(){
        let params = { processInstanceId: this.processId };
        processInstanceImage(params).then(res => {
          this.str = res.data
        });
        historicActivityInstance(params).then(res => {
          if (res.data.code == 200) {
            this.tableData = res.data.data;
            this.tableData.map((item, index) => {
              item.ids = index + 1;
            })
          }
        });
        let params2 = { id: this.id };
        getCustomerInfo(params2).then(res => {
          if (res.data.code == 200) {
            this.propsParams = res.data.data;
          }
        })
      },
    },
    created() {
      this.processId = this.$route.query.processId;
      this.id = this.$route.query.id;
    },
    mounted() {
      this.initData()
    },
  };
</script>

<style scoped lang="less">
@primary: #409EFF;
@primary-dark: #337ECC;
@text-primary: #303133;
@text-sub: #606266;
@text-light: #909399;
@bg-page: #F0F2F5;
@bg-header: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);
@border-color: #ebeef5;

.flow-page {
  min-height: 100vh;
  background: @bg-page;
  padding: 24px 16px 40px;
  box-sizing: border-box;
}

/* ================= 容器 ================= */
.table-container {
  max-width: 1100px;
  margin: 0 auto 16px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* ================= 标题区域 ================= */
.page-header {
  display: flex;
  align-items: center;
  padding: 20px 28px;
  background: @bg-header;
  color: #fff;
}
.header-bar {
  width: 5px;
  height: 36px;
  background: #fff;
  border-radius: 3px;
  margin-right: 14px;
  opacity: 0.85;
}
.header-content {
  flex: 1;
}
.header-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 1.2;
}
.header-sub {
  margin-top: 4px;
  font-size: 12px;
  letter-spacing: 1.5px;
  opacity: 0.7;
}

/* ================= 卡片内容区 ================= */
.card-body {
  padding: 16px 20px;
}

/* ================= 分组标题 ================= */
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: @text-primary;
  padding: 0 0 8px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    width: 4px;
    height: 16px;
    background: @primary;
    border-radius: 2px;
  }
}
.section-divider {
  height: 1px;
  background: #ebeef5;
  margin: 4px 0 12px;
}

/* ================= 信息展示 ================= */
.info-grid {
  .info-row {
    display: flex;
    gap: 24px;

    &:not(:last-child) {
      border-bottom: 1px solid #f5f7fa;
    }

      .info-item {
        flex: 1;
        display: flex;
        align-items: flex-start;
        padding: 10px 0;

      &--full {
        flex: 1 1 100%;
      }

      .info-label {
        flex-shrink: 0;
        width: 100px;
        font-size: 14px;
        color: @text-light;
        line-height: 22px;
      }

      .info-value {
        flex: 1;
        font-size: 14px;
        color: @text-primary;
        line-height: 22px;
        font-weight: 500;
        word-break: break-all;
      }
    }
  }
}

/* ================= 图片区 ================= */
.image-grid {
  display: flex;
  justify-content: center;
  gap: 80px;
  flex-wrap: wrap;
  padding: 8px 0;
}

.image-block {
  display: flex;
  flex-direction: column;
  align-items: center;

  .image-block-label {
    font-size: 14px;
    font-weight: 500;
    color: @text-sub;
    margin-bottom: 12px;
  }

  .image-wrap {
    width: 220px;
    height: 220px;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid @border-color;
  }

  .detail-image {
    width: 100%;
    height: 100%;
    display: block;
    cursor: pointer;

    /deep/ .el-image__inner {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    &:hover /deep/ .el-image__inner {
      transform: scale(1.03);
    }
  }

  .image-empty {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #fafbfc;
    color: @text-light;

    i { font-size: 40px; }
    span { font-size: 13px; }
  }
}

/* ================= 流程图 ================= */
.flow-diagram {
  text-align: center;

  /deep/ svg { max-width: 100%; }
  /deep/ img { max-width: 100%; }
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  color: @text-light;
  gap: 12px;

  i { font-size: 48px; }
  span { font-size: 14px; }
}

/* ================= 流程表格 ================= */
.flow-table-wrap {
  padding: 16px;
}

/* ================= 响应式 ================= */
@media (max-width: 768px) {
  .flow-page {
    padding: 16px 12px;
  }

  .page-header {
    padding: 16px 20px;
  }

  .header-title {
    font-size: 18px !important;
  }

  .card-body {
    padding: 12px 16px;
  }

  .info-row {
    flex-direction: column !important;
    gap: 0 !important;

    .info-item {
      padding: 10px 0 !important;
    }
  }

  .image-grid {
    gap: 40px !important;
  }

  .image-wrap {
    width: 180px !important;
    height: 180px !important;
  }
}
</style>